import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import MarketSnapshotsPage from 'lumen/components/market/snapshots/page';
import MarketSnapshotsTableLayout from 'lumen/components/market/snapshots/table-layout';
import type MarketSnapshotsBudgetController from 'lumen/controllers/market/snapshots/budget';
import type MarketSnapshotsBudgetRoute from 'lumen/routes/market/snapshots/budget';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSnapshotsBudgetSignature {
  Args: {
    controller: MarketSnapshotsBudgetController;
    model: ModelFrom<MarketSnapshotsBudgetRoute>;
  };
}

<template>
  <MarketSnapshotsPage
    @dates={{@controller.dates}}
    @kpiSection={{@controller.kpiSection}}
    @pagination={{@controller.pagination}}
    @table={{@controller.table}}
    @title={{t "market.snapshots.view.budget"}}
    @view="budget"
  >
    <:tableControls>
      <MarketSnapshotsTableLayout
        @manageColumns={{hash
          fixed=@controller.config.columns.fixed
          kpiSettings=@controller.kpiColumnSettings
          metrics=@controller.columnMetrics
          settings=@controller.columnSettings
        }}
        @onSave={{@controller.updateTableLayoutPreferences}}
        @tableLayoutPreferences={{@controller.tableLayoutPreferences}}
      />
    </:tableControls>
  </MarketSnapshotsPage>
</template> satisfies TOC<MarketSnapshotsBudgetSignature>;
